import 'select2';
import mask from './inc/mask';
import Swal from 'sweetalert2'

var userType = document.getElementById('form-field-aberto_pelo_portal_externo');
var fieldMatricula = document.getElementById('matricula');

$(() => {
    $('#dadosSolicitante').on('submit', function()
    {
        var form = $(this);
        var form_data = form.serialize();

        $.ajax({
            url: '/wp-ajax/api-service-now',
            method: 'POST',
            data: form_data,

            error: (xhr) => {
                console.log('erro: ', xhr);
            },

            success: (xhr) => {
                console.log('sucesso: ', xhr);
            }
        });
    });

    $('.elementor-form').on('submit', function(e)
    {
        e.preventDefault();

        if(fieldMatricula && checkFieldMatricula()) {
            Swal.fire({
                title: 'Matrícula obrigatória',
                html: 'Por favor, insira a matrícula para enviar o formulário.',
                icon: 'warning',
            });

            return;
        }

        const form = $(this);
        const form_data = new FormData(this);

        // Sempre preencher o campo matrícula
        if(!form_data.get('form_fields[matricula]')) {
            form_data.set('form_fields[matricula]', 'EX-FUNCIONÁRIO');
        }

        // Concatenar mensagem padrão para reset de senha
        if(form_data.get('form_fields[service_now]') == 'reset-de-senha') {
            let current_message = form_data.get('form_fields[description]') || '';
            let default_message = 'O solicitante encontrou dificuldades nos processos de reset de senha, cadastro de MFA ou desbloqueio de conta. Gentileza realizar a análise e providenciar o suporte necessário com base nas informações descritas por ele(a) a seguir:\n\n';
            form_data.set('form_fields[description]', default_message + current_message);
        }

        const target = form.find('input[name="form_fields[service_now]"]').val();

        // verifica se existe o campo service-now
        if(target) {
            $.ajax({
                url: '/wp-json/service-now/v2/' + target,
                method: 'POST',
                data: form_data,
                processData: false,
                contentType: false,

                error: (xhr) => {
                    console.log('erro: ', xhr);
                    Swal.fire({
                        title: 'Erro ao enviar formulário',
                        icon: 'error',
                    });
                },

                success: (xhr) => {
                    console.log('sucesso: ', xhr);
                    if(xhr.success === true) {
                        Swal.fire({
                            title: xhr.data.title,
                            html: xhr.data.message,
                            icon: 'success',
                        });
                    }

                    else {
                        console.log('error: ', xhr.console);
                        Swal.fire({
                            title: 'Erro ao enviar formulário',
                            html: xhr.data.message || 'Ocorreu um erro ao enviar o formulário. Tente novamente mais tarde.',
                            icon: 'error',
                        });
                    }

                }
            });
        }
    });
});

/**
 * Remove padrões inválidos do Elementor (regex-match)
 */
document.querySelectorAll('input[pattern*="regex-match"]').forEach((input) => {
    const match = input.getAttribute('pattern').match(/\/(.+)\//);
    input.setAttribute('pattern', match ? match[1] : '.*');
});

/**
 * Máscaras e validações
 */
document.addEventListener('input', (e) => {
    const input = e.target;

    // Máscara de telefone
    if(false
        || input.id === 'form-field-celular'
        || input.id === 'form-field-telefone'
        || input.id === 'form-field-telefone_celular'
    ) { input.value = mask.maskPhone(input.value); }

    // Máscara de CPF
    if(1 == 0
        || input.id === 'form-field-cpf_externo'
        || input.id === 'form-field-rh_cpf'
        || input.id === 'form-field-cpfex'
    ) { input.value = mask.maskCPF(input.value); }
});

/**
 * Validação do CPF
 */
document.addEventListener('focusout', (e) => {
    const input = e.target;

    // Quantidade de caracteres de CPF
    if(false
        || input.id === 'form-field-cpf_externo'
        || input.id === 'form-field-rh_cpf'
        || input.id === 'form-field-cpfex'
    ) {
        validateCharacteres(
            input.value,
            14,
            'O CPF não foi preenchido corretamente (999.999.999-99).'
        );
    }

    // Validação de email
    if(false
        || input.type === 'email'
        || input.type === 'e_mail'
    ) {
        // Verifica se o campo não está desabilitado
        if(input.hasAttribute('readonly') || input.hasAttribute('disabled')) {
            return;
        }

        // Regex simples para validação de email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if(!emailRegex.test(input.value)) {
            Swal.fire({
                title: 'Email inválido',
                html: 'Por favor, insira um endereço de email válido.',
                icon: 'error',
            });
        }
    }
});

function validateCharacteres(value, max, message)
{
    if(value.length < max) {
        Swal.fire({
            title: 'Erro',
            html: message,
            icon: 'error',
        });

        return false;
    }

    return true;
}

/**
 * Busca de usuário por matrícula
 */
function checkFieldMatricula() {
    let status = (false
        || (true
            && userType !== null
            && userType.value !== 'true'
            && fieldMatricula !== null
            && fieldMatricula.value === ''
        )
        || (true
            && userType === null
            && fieldMatricula !== null
            && fieldMatricula.value === ''
        )
    );

    return status;
}

function toggleServiceNowFields(deactivate = true)
{
    if(deactivate && checkFieldMatricula()) {
        // Deixar todos os campos do formulário somente leitura, exceto o campo de matrícula
        $('.elementor-form input, .elementor-form select, .elementor-form textarea, .elementor-form button:not(#buscar-matricula)')
            .not('#matricula, #form-field-aberto_pelo_portal_externo')
            .attr('readonly', true);
    } else {
        // Deixar todos os campos do formulário editáveis
        $('.elementor-form input, .elementor-form select, .elementor-form textarea, .elementor-form button:not(#buscar-matricula)')
            .removeAttr('readonly');
    }
}

toggleServiceNowFields();

const activeUser = document.getElementById('form-field-aberto_pelo_portal_externo');
if(activeUser) {
    activeUser.addEventListener('change', function()
    {
        toggleServiceNowFields();
    });
}

const btn_matricula = document.querySelector('#buscar-matricula');
if(btn_matricula) {

    function buscarUsuarioPorMatricula(e) {
        e.preventDefault();

        const register = fieldMatricula.value;
        if(!register || register.length < 4) {
            Swal.fire({
                title: 'Matrícula inválida',
                html: 'Por favor, insira uma matrícula válida com pelo menos 4 caracteres.',
                icon: 'warning',
            });

            return;
        }

        // Fazer a requisição AJAX para buscar os dados do usuário
        fetch(`/wp-json/service-now/v2/check-registration?registration=${register}`)
        .then(response => response.json())
        .then(data => {
            if(data.length > 0) {
                const user = data[0];

                $('#form-field-caller_id').val(user.id || '');
                $('#form-field-nome').val(user.text || '');
                $('#form-field-registration[type=hidden]').val(user.matricula || '');
                $('#form-field-e_mail[type=hidden]').val(user.email || '');

                let location_id = user.u_localidade_atendimento;
                if(location_id) {
                    const hideField = (selector, value) => {
                        const $field = $(selector);
                        $field.parents('.elementor-field-type-select').css({ overflow: 'hidden', height: 0, width: 0, position: 'absolute' });
                        $field.replaceWith(`<input type="hidden" id="${$field.attr('id')}" name="${$field.attr('name')}" value="${value}">`);
                    };

                    hideField('#form-field-location_country', user.country);
                    hideField('#form-field-location_state', user.state);
                    hideField('#form-field-location_city', user.city);
                    hideField('#form-field-location', location_id);
                }

                let description = $('#form-field-description').val();
                if(description) {
                    description = description.replace('{name}', user.name || '');
                    description = description.replace('{login}', user.u_matricula || '');
                    $('#form-field-description').val(description);
                }

                // Substituir nome do meio por *
                const nameParts = user.text.split(' ');
                nameParts.length
                if(nameParts.length > 2) {
                    for(let i = 1; i < nameParts.length - 1; i++) {
                        nameParts[i] = '*****';
                    }
                }
                const maskedName = nameParts.join(' ');

                Swal.fire({
                    title: 'Usuário encontrado',
                    html: maskedName,
                    icon: 'success',
                });

                toggleServiceNowFields(false);
            }

            else {
                Swal.fire({
                    title: 'Usuário não encontrado',
                    html: 'Nenhum usuário foi encontrado com a matrícula fornecida.',
                    icon: 'warning',
                });

                fieldMatricula.value = '';

                toggleServiceNowFields(true);
            }
        });
    }

    //fieldMatricula.addEventListener('change', buscarUsuarioPorMatricula);
    btn_matricula.addEventListener('click', buscarUsuarioPorMatricula);
}

/**
 * Preencher campos de localização pelo Service Now
 */
$(function()
{
    // Buscar países
    fetch('/wp-json/service-now/v2/get-location')
        .then(response => response.json())
        .then(data => {
            data.forEach(location => {
                $('#form-field-location_country').append(new Option(location.name, location.sys_id));
            });
        });

    // Buscar estados ao selecionar país
    $('#form-field-location_country').on('change', function()
    {
        const country = $(this).val();

        $('#form-field-location_state').empty().append(new Option('', ''));
        $('#form-field-location_city').empty().append(new Option('', ''));
        $('#form-field-location').empty().append(new Option('', ''));

        fetch(`/wp-json/service-now/v2/get-location?parent=${country}`)
            .then(response => response.json())
            .then(data => {
                data.forEach(location => {
                    $('#form-field-location_state').append(new Option(location.name, location.sys_id));
                });
            });
    });

    // Buscar cidades ao selecionar estado
    $('#form-field-location_state').on('change', function()
    {
        const state = $(this).val();

        $('#form-field-location_city').empty().append(new Option('', ''));
        $('#form-field-location').empty().append(new Option('', ''));

        fetch(`/wp-json/service-now/v2/get-location?parent=${state}`)
            .then(response => response.json())
            .then(data => {
                data.forEach(location => {
                    $('#form-field-location_city').append(new Option(location.name, location.sys_id));
                });
            });
    });

    // Buscar localidades ao selecionar cidade
    $('#form-field-location_city').on('change', function()
    {
        const city = $(this).val();

        $('#form-field-location').empty().append(new Option('', ''));

        fetch(`/wp-json/service-now/v2/get-location?parent=${city}`)
            .then(response => response.json())
            .then(data => {
                data.forEach(location => {
                    $('#form-field-location').append(new Option(location.name, location.sys_id));
                });
            });
    });
});

if(fieldMatricula) {
    fieldMatricula.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
            event.preventDefault();
            btn_matricula.click();
        }
    });
}
